import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css'; // ✅ Un solo archivo para todos los estilos globales
import './styles/xphub-tokens.css'; // Tokens visuales prefijados para rediseños reversibles
import './styles/xphub-effects.css'; // Efectos reutilizables sin tocar estilos legacy
import './styles/xphub-layout.css'; // Primitivas de layout/card/botones con clases xh-*
import 'slick-carousel/slick/slick.css'; // ✅ Estilos base de react-slick
import 'slick-carousel/slick/slick-theme.css'; // ✅ Tema react-slick
import 'react-loading-skeleton/dist/skeleton.css'; // ✅ Skeleton loaders
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';
import AdPlacementsRail from "./components/AdPlacementsRail";
import { recordWebVitalMetric, startRuntimeTelemetry } from "./analytics/telemetry";
import { installNavigationEvents } from "./utils/navigationEvents";

installNavigationEvents();
startRuntimeTelemetry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <AdPlacementsRail />
  </React.StrictMode>
);

reportWebVitals(recordWebVitalMetric);
